import React, {useState} from 'react';
import {ReactComponent as CoinsIco} from "../../../images/icons/coins.svg";
import {useTranslation} from "react-i18next";
import ErrorFormHelper from "../../utils/ErrorFormHelper";
import ErrorFormView from "../Common/ErrorFormView";
import PopupModal from "../Modal/PopupModal";

interface Props {
	onHide: () => void;
	handleSave: (tipAmount?: number) => void;
	tipAmount?: number;
	errors: any[];
	currency: string;
}

const CartTipModal = ({onHide, handleSave, tipAmount, errors, currency}: Props) => {
	const {t} = useTranslation();
	const [amount, setAmount] = useState<number | undefined>(tipAmount);

	const handleChangeAmount = (event: React.FocusEvent<HTMLInputElement> |  React.ChangeEvent<HTMLInputElement>) => {
		if(!event.target.value){
			setAmount(undefined)
			return;
		}
		const value = Number(event.target.value);

		if (value < 0) {
			setAmount(Math.abs(value));
			return;
		}

		if (isNaN(value)) {
			setAmount(0)
		}
		else {
			setAmount(value)
		}
	}

	const onSaveClick = () => {
		handleSave(amount);
		onHide();
	}

	return <PopupModal
		bodyContent={
			<div className="my-3 w-100">
				<div className="form-group tip-input-wrapper">
					<div className="input-group">
						<input onBlur={handleChangeAmount} value={amount}
							   onChange={handleChangeAmount}
							   type="number"
							   step="0.01"
							   className={"form-control" + ErrorFormHelper(errors, "amount")}
							   id="tip"
							   min="0"
							   placeholder={t("modules.cart.field.tip.placeholder")}/>
						<span className="input-group-text">{currency}</span>
					</div>
					<ErrorFormView errors={errors} field="amount"/>
				</div>
			</div>
		}
		title={t("modules.cart.field.tip.title")}
		show
		headerIcon={<CoinsIco/>}
		onHide={onHide}
		cancelButton
		primaryButton={
			<button className={"btn btn-lg btn-primary flex-grow-1"} onClick={onSaveClick}>
				{t("common.action.save")}
			</button>
		}
	/>
}

export default CartTipModal;